import React, { Component } from 'react'
import './NotFound.scss'
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class NotFound extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');
        

        ReactPixel.pageView();
        
    }

    render() {
        return (
            <div className="notFound">
                <div id="wrapper">
                    <div className="container">
                        <div className="info">
                            <h1>Oops!</h1>
                            <h2>Where are we?</h2>
                            <p>
                                The page you are looking for was moved, removed, renamed or <br/>might never existed.
                            </p>
                            <a href="/" className="btn">Go Home</a>
                        </div>
                        <div className="bear">
                            <div className="zzz"></div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
export default  NotFound
